import { render } from "./QnAView.vue?vue&type=template&id=287c591a&scoped=true"
import script from "./QnAView.vue?vue&type=script&lang=js"
export * from "./QnAView.vue?vue&type=script&lang=js"

import "./QnAView.vue?vue&type=style&index=0&id=287c591a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287c591a"]])

export default __exports__